import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal } from 'react-bootstrap'
import UserService from "../../controllers/UserService";
import AuthService from "../../controllers/AuthService";
import $ from 'jquery'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Helmet from 'react-helmet';


const RFStudentList = props => {
    
    const { roomId } = useParams();
    // const currentUser = AuthService.getCurrentUser();
    // const userId = AuthService.getCurrentUser().id;
    const userRole = AuthService.getUserRole();
    let [stdList, setStdList] = useState([]);
    const [modalShow, setModalShow] = useState(false);
 
    useEffect(() => {
        
        try {  
            let filter = {};
           
            UserService.getRiasecStudentInRoom(roomId).then((response) => {
                console.log(response.data.data)
                var tempStd = response.data.data;
                tempStd.sort(function (a, b) { return a['student']['no'] - b['student']['no']; });
                setStdList(tempStd);
            }).then(() => { 
                
            })
           
        } catch (error) {

        }
        
    }, []);
    

    function selectionChange(){
        var e = document.getElementById("selection-riasec");
        var selectValue = e.value;
        var temp = $('#search').val();
        // var count1 = 1;
        if (!selectValue) {
            selectValue = 'all'
        }
        $('.div-detail').each(function(i, obj) {  
            let studentName = obj.querySelector('.student-name').innerHTML + obj.querySelector('.student-no').innerHTML;
            let isDone = obj.classList.contains('status-true')
            var checkStatus = studentName.includes(temp);

            if(
                (checkStatus && selectValue === 'done' && isDone) ||
                (checkStatus && selectValue === 'notdone' && !isDone) || 
                (checkStatus && selectValue === 'all')
            ){
                $(obj).show();
               
            } else {
                $(obj).hide();
            }
        });
    }


    function copyToClipboard(index, alertText) {
        var element = document.getElementById(index);
        var copyText = element.value;  
        navigator.clipboard.writeText(copyText);      
        var element2 = document.getElementById(alertText);
        element2.classList.remove("d-none");
        
        setTimeout(() => {  element2.classList.add("d-none"); }, 3000)
        
      }

    return (
        <div className="mb-5 riasec-list">
            <Helmet>
                <title>แบบประเมิน RIASEC - Mindsetmaker.co</title>
                <meta property="og:title"       content={`แบบประเมิน RIASEC - Mindsetmaker.co`} />
                <meta property="og:description" content={`แบบประเมิน RIASEC`} />
            </Helmet>
            <div className="px-4 main-detail">
               
                <Row className="px-0" >
                        <Col>
                            <h2 class="primary-text pb-3 py-md-3 mt-4 font-sarabun-bold text-center">แบบประเมิน RIASEC</h2>                    
                        </Col>
                        <Col xs={12} className="w-100 pb-3 px-0">
                            <div className="w-100 px-0" id="search-div">
                                <FontAwesomeIcon icon={faSearch} className="gray-text3 icon-search"></FontAwesomeIcon>
                                <input className="form-control form-control-sm w-100 border-radius-5 search" type="text" id="search" placeholder="ค้นหา ชื่อ-นามสกุล หรือเลขที่" onInput={() => selectionChange()} />
                            </div>
                        </Col>
                        <Col><u className='text-green-evaluate click-pointer' onClick={() => { setModalShow(true); }}>RIASEC คืออะไร?</u></Col>
                            
                </Row>
                <Row className="blue-bg py-2 mt-3">
                    <Col xs={2} md={2} className="text-center pr-0 gray-text3 font-sarabun-bold">เลขที่</Col>
                    <Col xs={7} md={8} className="text-center gray-text3 font-sarabun-bold"><span className="pr-md-5 mr-md-5">ชื่อ - นามสกุล</span><span className="pr-md-5 mr-md-5"></span><span className="pr-md-5 mr-md-5"></span></Col>                 
                    <Col xs={3} md={2} className="text-center px-0 gray-text3 font-sarabun-bold" style={{"position": "relative"}}>
                            <select id="selection-riasec" className="selection-riasec gray-text3" onChange={() => { selectionChange() }}>  
                                <option value="" selected disabled hidden>สถานะ</option>
                                <option value="all">ทั้งหมด</option>
                                <option value="done">ประเมินแล้ว</option>
                                <option value="notdone">ยังไม่ประเมิน</option>
                            </select>     

                    </Col>
                </Row>
                {
                        (stdList) ? (
                            stdList.map((item, index) => (  
                                <Row data-testid="student-row" key={index.toString()} className={`border-bottom-blue py-3 div-detail status-${item.doneByTeacher}`}> 
                                    <Col xs={2} md={2} className="text-center my-1"><h5 data-testid="student-no" className="mb-0 font-weight-600 order student-no">{item.student.no}</h5></Col>
                                    <Col xs={7} md={8} className="text-left my-1">
                                        <p data-testid="student-name" className="student-name m-0">{item.student.fullName}</p>                                       
                                        <p> 
                                        <textarea id={`${index}-content`} className='d-none'>{`${process.env.REACT_APP_URL}riasec/evaluate/${item.student.id}/parent`}</textarea>
                                        <p data-testid="parent-link" onClick={() => copyToClipboard(`${index}-content`, `${index}-copied-text`)} className="t-14 text-green-evaluate click-pointer"><u>ลิงก์สำหรับผู้ปกครองประเมิน</u> <span className={`d-none mt-0  text--black`} id={`${index}-copied-text`}>คัดลอกลิงค์เรียบร้อยแล้ว</span></p>
                                        
                                        </p>
                                    </Col>
                                    <Col xs={3} md={2} className="text-center my-1" data-testid="student-riasec-status"><a href={`/riasec/evaluate/${item.student.id}`}><Button className="bg-lightness4-blue  border-0px click-pointer btn font-sarabun-bold t-12 btn font-sarabun-bold text--black">ประเมิน</Button></a></Col>
                                </Row>
                                ))
                            ) : (
                                <div></div>
                            )
                }
            </div>
            <MyVerticallyCenteredModal
                    show={modalShow}
                    onHide={() => { setModalShow(false); }}
                />
        </div>
    )


    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className="strength-modal"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                <Row className="pt-0 pb-4 person-choose-strength px-md-4">
                      <Col>
                      {/* ---------------------------------------------------- */}
                      <div className="px-2 px-md-4 w-100">
             
                              <Row className="px-0" >
                                      <Col xs={12}>
                                          <h2 class="text-green pb-3 py-md-3 text-center">RIASEC คืออะไร?</h2>                   
                                          <p className='font-sarabun-bold'>ค้นหาตัวตนผ่านมิติอาชีพอย่างครบถ้วนตามทฤษฎีของ Prof. John Holland (RIASEC) ด้วย Task-based Activitie</p> 
                                      </Col>         
                                      <Col xs={12}>
                                          <h2 class="text-green pb-3 py-md-3 text-center">ทฤษฎีของ Holland</h2>          
                                          <p className='font-sarabun-bold'>
                                              <ul>                                    
                                                  <li>ได้รับการยอมรับและถูกนำไปใช้ในการให้คำปรึกษาด้านอาชีพอย่างกว้างขวาง</li>
                                                  <li>รับรองโดยงานวิจัยที่ต่อเนื่องกว่า 60 ปี</li>
                                                  <li>ถูกนำไปใช้ในโรงเรียน มหาวิทยาลัยและองค์กรทั่วโลก</li>
                                                  <li>ใช้โดยกระทรวงแรงงานของสหรัฐอเมริกา</li>
                                                  <li>ใช้โดยหน่วยงานรัฐบาลทั่วโลก เช่น ออสเตรเลีย แคนาดา สวิตเซอร์แลนด์ ฯลฯ</li>
                                              </ul>
                                          </p>          
                                      </Col>              
                                          
                              </Row>
                              <Row className="py-2 mt-3">
                                  <Col xs={12} md={5} className="">
                                      <img src='/images/riasec/riasec_meaning.png' width={'100%'} alt='Riasec Meaning' /> 
                                  </Col>
                                  <Col xs={12} md={7} className="d-flex">
                                      <div className='blue-bg p-3 p-md-5 t-1 m-auto font-sarabun-bold border-radius-125'>
                                          <p className='text-indent-18'><span className='text-green'>R:</span> ชอบการลงมือทำจริงชอบกีฬาและกิจกรรมกลางแจ้ง</p>
                                          <p className='text-indent-18'><span className='text-green'>I:</span> สนใจในวิทยาศาสตร์และการแสวงหาความรู้แขนงต่างๆ</p>
                                          <p className='text-indent-18'><span className='text-green'>A:</span> ชอบช่วยเหลือผู้อื่น อยากเห็นผู้อื่นพัฒนาชอบสร้างความสัมพันธ์ที่ดีกับคนรอบข้าง</p>
                                          <p className='text-indent-18'><span className='text-green'>S:</span> มีความคิดสร้างสรรค์มีจินตนาการ เชื่อในสัญชาตญาณของตัวเอง</p>
                                          <p className='text-indent-18'><span className='text-green'>E:</span> มีความเป็นผู้นำสามารถโน้มน้าวใจ และมีอิทธิพลต่อการตัดสินใจของผู้อื่น</p>
                                          <p className='text-indent-18'><span className='text-green'>C:</span> ชอบจัดระบบข้อมูลตัวเลข มีความเป็นระเบียบสูง</p>
                                      </div>    
                                  </Col>                                    
                              </Row>                
                          </div>

                      {/* ---------------------------------------------------- */}
                      </Col>
                  </Row>
                </Modal.Body>
            </Modal>
        );
    }
}


export default RFStudentList